import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Willkommen zurück");
      nav("/admin", { replace: true });
    } else {
      toast.error("Anmeldung fehlgeschlagen", { description: res.error });
    }
  };

  return (
    <div className="admin-shell flex items-center justify-center p-6" style={{ minHeight: "100vh" }}>
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white border border-neutral-200 rounded-3xl p-8 shadow-xl"
        data-testid="admin-login-form"
      >
        <div className="text-center mb-8">
          <div className="text-2xl font-light tracking-[.14em] text-neutral-900">LET'S BAU</div>
          <div className="text-xs uppercase tracking-[.18em] text-neutral-500 mt-2">Admin</div>
        </div>
        <div className="grid gap-4">
          <div className="grid gap-2">
            <Label htmlFor="email" className="text-neutral-700">E-Mail</Label>
            <Input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="bg-neutral-50 border-neutral-200 text-neutral-900"
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="pw" className="text-neutral-700">Passwort</Label>
            <Input
              id="pw"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              className="bg-neutral-50 border-neutral-200 text-neutral-900"
            />
          </div>
          <button type="submit" disabled={loading} className="lbtn primary mt-2" data-testid="admin-login-submit">
            {loading ? "Anmelden..." : "Anmelden"}
          </button>
        </div>
      </form>
    </div>
  );
}
